import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import pillarsLogo from "../assets/logo/pillars.svg";

// PORTS OF `_pages/not-authorized`, `_pages/notfound` AND `_pages/notification-trigger`: THE
// LOGIN PAGE'S GRADIENT FRAME AND CARD WITH A CODE, A HEADING AND A LINE, ALL VERBATIM
// ("YOUR NOT AUTHORIZED" INCLUDED). "BACK TO DASHBOARD" IS A PLAIN LINK HOME. THEY SIT OUTSIDE
// THE APP SHELL, AS IN ANGULAR.
function StatusCard({ code, title, line }: { code: string; title: string; line: string }) {
  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
      <div className="flex flex-column align-items-center justify-content-center">
        <div style={{ borderRadius: 56, padding: "0.3rem", background: "linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)" }}>
          <div className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: 53 }}>
            <div className="text-center mb-5">
              <img src={pillarsLogo} alt="logo" height={75} className="mb-3" />
              <div className="text-900 text-3xl font-medium mb-3">pillars</div>
            </div>
            <div className="text-center">
              <span className="text-blue-500 font-bold text-3xl">{code}</span>
              <h1 className="text-900 font-bold text-3xl lg:text-5xl mb-2">{title}</h1>
              <div className="text-600 mb-5">{line}</div>
              <div className="mb-5">
                <a href="/">Back to dashboard</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const NotAuthorizedPage = () => <StatusCard code="401" title="Not Authorized" line="Your not authorized to access the requested resource." />;

export const NotFoundPage = () => <StatusCard code="404" title="Not Found" line="Requested resource is not available." />;

// `/tabs/active`: THE NATIVE APPS' NOTIFICATION TAP. WITH BOTH `cmsPlayerId` AND `playerId` IN THE
// QUERY IT GOES TO IN PLAY (ANGULAR IGNORES THE IDS BEYOND THAT CHECK); OTHERWISE IT SHOWS THE 404
export function NotificationTriggerPage() {
  const navigate = useNavigate();
  const params = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const go = !!params.get("cmsPlayerId") && !!params.get("playerId");
  useEffect(() => {
    if (go) void navigate({ to: "/in-play", replace: true });
  }, [go, navigate]);
  return <StatusCard code="404" title="Not Found" line="Requested resource is not available." />;
}
